module.exports = __webpack_public_path__ + "img/algeria.bae15676.svg";